import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import { isAuthenticated } from '../auth';
import { Link, useParams } from "react-router-dom";
import { Tag, Trash2, Plus, AlertTriangle, ArrowLeft } from "lucide-react";
import { getFilterByID, updateFiltersValue, removeFilterValue } from "../auth/apiCategory";
import Modal from 'react-bootstrap/Modal';
import { elakayAutoText } from "../pageInside/dataElakay";
import "./adminPages.css";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#d1fae5",
  red: "#ef4444", redLt: "#fee2e2",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addFilterValues"]?.[key] || fallback;

const CreatCategory = props => {
    const {
        infoSource,
        laguangeElakay
            } = props;

  __setElakayInfoSource(infoSource);
        const {
           getButtonTitle
        } = infoSource;

    let params = useParams()
    const [name, setFilters] = useState("");
    const [getCartItems, setgetCart] = useState([]);
    const [filter, setfilter] = useState([]);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState([]);

    // destructure user and token from localstorage
    const { token } = isAuthenticated();
    const filterID = params.filterID
    const [showDeleteAgree, setDeleteAgree] = useState(false);
    const [chek, setChek] = useState(false);
    const [seletName, setSeletName] = useState('');
    const handl = (a) => {
        setChek(a)
    }
    // creat button filter is true
    const filterButton = true

    // load categories and set form data
    const loadFilters = (filterID, token) => {
        getFilterByID(filterID, token).then(data => {
            if (data.error) {
            } else {
                setfilter(data)
                setLoading(false)
            }
        });
    };


    const clickSubmit = e => {
        e.preventDefault();

        setError("");
        setSuccess(false);
        // make request to api to create category
        updateFiltersValue(token, filterID, { name }).then(data => {
            if (data.error) {
                // loadCategory(elakayCategoryID);
                setError(data.error);
            } else {

                setError("");
                setSuccess(true);
                setMessage(elakayAutoText("h_6b00272504365f", "the filters name: {value0} is Create in {value1}", { value0: name, value1: filter.name }))
                setFilters("")
                loadFilters(filterID, token)
            }
        });
    };


    const deleteFIL = (filterID, name, token) => {
        removeFilterValue(filterID, {name}, token).then(data => {
            if (data.error) {
                setError(data.error);
                // loadCategory(categoryID)
            } else {
                setError(false);
                setSuccess(true);
                setMessage(elakayAutoText("h_6b00272504365f", "the filters name: {value0} is Create in {value1}", { value0: name, value1: filter.name }))
                setFilters("")
                loadFilters(filterID, token)
                setDeleteAgree(false)
                setChek(false)
            }
        });
    };

    useEffect(() => {
        loadFilters(filterID, token);
    }, [filterID, token]);

    const handleChange = event => {
        setFilters(event.target.value)
    };

    const SubmitB = (name) => {
        setSeletName(name)
        setDeleteAgree(true)

    }

    // ─── Shared primitives ───────────────────────────────────────────────────
    const showSuccess = () => !success ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.greenLt, borderRadius: 8, border: "1px solid #86efac", marginBottom: 14 }}>
        <span style={{ fontSize: 12, color: "#065f46", fontWeight: 500 }}>{message}</span>
      </div>
    );

    const showError = () => !error ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 14 }}>
        <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{error}</span>
      </div>
    );

    const deleteAgree = (name, filterID, token) => (
      <Modal show={showDeleteAgree} onHide={() => setDeleteAgree(false)} centered aria-labelledby="delete-filter-value-title">
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="delete-filter-value-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.redLt, color: "#991b1b", flexShrink: 0 }}>
              <Trash2 size={16} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {infoSource.language(infoSource, "title", "delThtems")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
          <p style={{ fontSize: 13, color: D.txt2 }}>
            {infoSource.language(infoSource, "title", "surToDelete")}
            <span style={{ color: D.red, fontWeight: 700 }}> {name}</span>
          </p>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: D.txt2, cursor: "pointer" }}>
            <input
              onChange={() => handl(chek ? false : true)}
              type="checkbox"
              checked={chek}
              onClick={e => e.stopPropagation()}
              style={{ width: 16, height: 16, cursor: "pointer" }}
            />
            {infoSource.language(infoSource, "title", "chButAgree")}
          </label>
        </Modal.Body>
        <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
          <button
            onClick={chek ? () => deleteFIL(filterID, name, token) : undefined}
            disabled={!chek}
            style={{
              padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
              fontFamily: D.font, cursor: chek ? "pointer" : "not-allowed",
              background: chek ? D.red : "#cbd5e1", color: chek ? "#fff" : "#94a3b8",
            }}
          >
            {infoSource.language(infoSource, 'Button', "submit")}
          </button>
        </Modal.Footer>
      </Modal>
    );

    const CategoryFom = () => (
        <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: 12, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
                <Tag size={20} />
              </span>
              <h1 style={{ fontSize: 19, fontWeight: 700, color: D.txt1, margin: 0 }}>
                {__elakayText("t002", "Value of")} {filter.name}
              </h1>
            </div>
            {showSuccess()}
            {showError()}

            <div className="admin-card" style={{ marginBottom: 16, overflow: "hidden" }}>
                {filter._id && filter.FilterItem?.map((c, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 16px", borderBottom: `1px solid ${D.border}` }}>
                        <span style={{ flex: 1, fontSize: 13, color: D.txt1, fontWeight: 500 }}>{c}</span>
                        <button
                          type="button"
                          onClick={() => SubmitB(c)}
                          title={getButtonTitle("deleteFilter")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.redLt; e.currentTarget.style.color = D.red; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Trash2 size={15} />
                        </button>
                        {(c === seletName) && deleteAgree(c, filter._id, token)}
                    </div>
                ))}

                <form onSubmit={clickSubmit} style={{ display: "flex", gap: 10, padding: 16 }}>
                    <input
                        onBlur={() => setMessage("")}
                        type="text"
                        style={{ flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, outline: "none", fontFamily: D.font, boxSizing: "border-box" }}
                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addFilterValues.t001}
                        onChange={handleChange}
                        value={name}
                        autoFocus
                        required
                    />
                    <button
                      type="submit"
                      title={getButtonTitle("addNew")}
                      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 38, height: 38, borderRadius: 8, border: "none", background: D.blue, color: "#fff", cursor: "pointer", flexShrink: 0 }}
                    >
                      <Plus size={18} />
                    </button>
                </form>
            </div>
        </div>

    );

    const createCategoryButton = () => (
        <Link to={`/filters`} style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: D.blue, textDecoration: "none" }}>
          <ArrowLeft size={14} />
          {infoSource.language(infoSource, "Link", "ViElakayFil")}
        </Link>
    )

    return (
        <Layout
            infoSource ={infoSource}
            className="container blockEl"
            SliderPunShow={false}
            loading={loading}
            {...infoSource?.allSettings?.layout}
        >
            <div style={infoSource.styleNav}>
            <div className="admin-container" style={{ maxWidth: 720, fontFamily: D.font }} onBlur={() => setMessage("")}>
                {CategoryFom()}
                {createCategoryButton()}
            </div>
            </div>
        </Layout>
    );

};

export default CreatCategory;
